import type { BoxProps } from '@mui/material/Box';

import { Card, Container, Tab, Tabs } from '@mui/material';
import { useTabs } from 'minimal-shared/hooks';
import { varAlpha } from 'minimal-shared/utils';

import { DetailsDescription } from './DetailsDescription';
import { DetailsSection } from '@/types/sections/DetailsSection';
import { DetailsFiles } from './DetailsFiles';

type DetailsProps = BoxProps & {
  section: DetailsSection;
};

export default function Details({ sx, section, ...other }: DetailsProps) {
  const tabs = useTabs(section.tabs[0]?.key || '');
  const selectedTabDetails = section.tabs.find((tab) => tab.key === tabs.value);

  return (
    <Container sx={{ mt: { xs: 2, md: 10 }, mb: 10 }}>
      <Card sx={{ borderRadius: 0 }}>
        <Tabs
          value={tabs.value}
          onChange={tabs.onChange}
          sx={[
            (theme) => ({
              px: 3,
              boxShadow: `inset 0 -2px 0 0 ${varAlpha(theme.vars.palette.grey['500Channel'], 0.08)}`,
            }),
          ]}>
          { section.tabs.map((tab) => ( <Tab key={tab.key} value={tab.key} label={tab.type === 'files' ? `${tab.title} (${tab.files?.length})` : tab.title} /> ))}
        </Tabs>

        {selectedTabDetails?.type === 'description' && <DetailsDescription description={selectedTabDetails.text} />}
        {selectedTabDetails?.type === 'files' && <DetailsFiles files={selectedTabDetails.files} />}
      </Card>
    </Container>
  );
}
